import React, { createContext, useContext } from 'react'

const BuilderWidgetContext = createContext(false)
const BuilderCategoryContext = createContext(false)

export const BuilderWidgetProvider: React.FC<{ categoryManagedExternally?: boolean }> = ({
  children,
  categoryManagedExternally = false,
}) => (
  <BuilderWidgetContext.Provider value={true}>
    <BuilderCategoryContext.Provider value={categoryManagedExternally}>{children}</BuilderCategoryContext.Provider>
  </BuilderWidgetContext.Provider>
)

export const useBuilderWidget = () => useContext(BuilderWidgetContext)

export const useBuilderCategoryMode = () => useContext(BuilderCategoryContext)
